import { render } from "./Synopsis.vue?vue&type=template&id=4fa895e2&scoped=true"
import script from "./Synopsis.vue?vue&type=script&lang=js"
export * from "./Synopsis.vue?vue&type=script&lang=js"

import "./Synopsis.vue?vue&type=style&index=0&id=4fa895e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa895e2"]])

export default __exports__